/**
 * Cookie Management Module
 * Handles age verification, cookie retrieval, expiry management, and Shopify cookie tracking
 */

(function() {
  'use strict';

  // ============================================================================
  // Basic Cookie Helpers
  // ============================================================================

  /**
   * Set a cookie with name, value, and expiry (in days)
   * @param {string} n - Cookie name
   * @param {string} v - Cookie value
   * @param {number} d - Days until expiry
   */
  function setCookie(n, v, d) {
    var date = new Date();
    date.setTime(date.getTime() + (d * 24 * 60 * 60 * 1000));
    document.cookie = n + '=' + v + '; expires=' + date.toUTCString() + '; path=/';
  }

  /**
   * Get a single cookie by name
   * @param {string} n - Cookie name
   * @returns {string|null}
   */
  function getCookie(n) {
    return document.cookie.split('; ').reduce((r, c) => {
      const t = c.split('=');
      return t[0] === n ? t[1] : r;
    }, null);
  }

  // ============================================================================
  // Age Verification Popup
  // ============================================================================

  function initAgeVerification() {
    var agePopup = document.getElementById('age-popup');
    if (!agePopup) return;

    if (!getCookie('age_verified')) {
      agePopup.classList.add('show');
      document.body.classList.add('age-verified-show');
    }

    var acceptBtn = document.getElementById('age-accept');
    if (acceptBtn) {
      acceptBtn.onclick = function() {
        setCookie('age_verified', 'yes', 1);
        agePopup.classList.remove('show');
        document.body.classList.remove('age-verified-show');
      };
    }
  }

  // ============================================================================
  // Initialization
  // ============================================================================

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initAgeVerification();
      });
    } else {
      initAgeVerification();
    }
  }

  // ============================================================================
  // Public API
  // ============================================================================

  // Expose on window for use in theme and external scripts
  if (typeof window !== 'undefined') {
    window.CookieManagement = {
      setCookie: setCookie,
      getCookie: getCookie,
    };
  }

  // Initialize on load
  init();
})();
